var React = require('react');
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');
var Debounce = require('debounce');
var MultiSelect = require('./Multiselect');
var FoundationSlider = require('./FoundationSlider');

var initialDistance = 200;
var maxDistance = 200;
var minDistance = 5;
var distanceStep = 5;
var distanceSliderId = "searchDistance";
var debounceDelayInMillis = 800;

var trainingPeaksCertificationTooltips = {
	1: "<strong>Level 1 Coach</strong><p>Level 1 coaches have passed the TrainingPeaks accreditation course and have shown that they have the knowledge and skill to help you reach your goals.</p><p><a href='http://help.trainingpeaks.com/hc/en-us/articles/226323367-TrainingPeaks-Level-1-Certified-Coach' class='u-text-tp-blue' target=\"_blank\">Learn More about TrainingPeaks Level 1 Coaches</a></p>",
	2: "<strong>Level 2 Coach</strong><p>This is the highest level of TrainingPeaks accreditation. Level 2 coaches have completed TrainingPeaks University and have demonstrated their ability to utilize metrics in TrainingPeaks. They can provide you with the expert instruction and feedback you need to achieve your goals.</p><p><a class='u-text-tp-blue' href='http://help.trainingpeaks.com/hc/en-us/articles/226260048-TrainingPeaks-Level-2-Certified-Coach' target=\"_blank\">Learn More about TrainingPeaks Level 2 Coaches</a></p>"
};

var CoachSearchForm = createReactClass({
	propTypes: {
		onSearchSubmit: PropTypes.func.isRequired,
		sportTypeOptions: PropTypes.array.isRequired,
		serviceOptions: PropTypes.array.isRequired,
		languageOptions: PropTypes.array.isRequired,
		abilityLevelOptions: PropTypes.array.isRequired,
		genderOptions: PropTypes.array.isRequired,
		trainingPeaksCertificationOptions: PropTypes.array.isRequired,
		distanceUnitOptions: PropTypes.array.isRequired,
	},

	componentDidMount: function () {
		this.toggleDistanceDisplay();

		this.search = Debounce(this.search, debounceDelayInMillis);
		$('form.advancedSearchForm .tooltipster-tooltip').tooltipster({
			contentAsHTML: true,
			theme: 'tooltipster-shadow',
			interactive: true,
			maxWidth: 350
		});

		if (this.props.initialSearch) {
			this.search();
		}
	},

	getInitialState: function () {
		if (this.props.initialSearch) {
			return {
				keywords: (this.props.initialSearch.keywords) ? (this.props.initialSearch.keywords) : "",
				location: (this.props.initialSearch.location) ? (this.props.initialSearch.location) : "",
				distance: parseInt(this.props.initialSearch.radius) || initialDistance,
				distanceInput: parseInt(this.props.initialSearch.radius) || initialDistance,
				selectedDistanceUnits: (this.props.initialSearch.units) ? (this.props.initialSearch.units) : "mi",
				selectedSportTypeValues: (this.props.initialSearch.sportTypes) ? (this.props.initialSearch.sportTypes) : "",
				selectedServiceValues: (this.props.initialSearch.services) ? (this.props.initialSearch.services) : "",
				selectedLanguageValues: (this.props.initialSearch.languages) ? (this.props.initialSearch.languages) : "",
				selectedAbilityLevelValues: (this.props.initialSearch.abilityLevels) ? (this.props.initialSearch.abilityLevels) : "",
				selectedGenderValues: this.props.initialSearch.genders ? this.props.initialSearch.genders.toUpperCase().split(",") : [],
				selectedTrainingPeaksCertificationLevelValues: this.props.initialSearch.trainingPeaksCertifications ? this.props.initialSearch.trainingPeaksCertifications.split(",").map(function (i, v) { return parseInt(i); }) : []
			};
		} else {
			return {
				keywords: "",
				location: "",
				distance: initialDistance,
				distanceInput: initialDistance,
				selectedDistanceUnits: "mi",
				selectedSportTypeValues: "",
				selectedServiceValues: "",
				selectedLanguageValues: "",
				selectedAbilityLevelValues: "",
				selectedGenderValues: [],
				selectedTrainingPeaksCertificationLevelValues: []
			};
		}
	},

	showDistanceAndUnits() {
		return this.state.location.length > 0;
	},

	search: function () {
		var searchParams = {
			keywords: this.state.keywords.trim(),
			location: this.state.location,
			radius: this.state.distance,
			units: this.state.selectedDistanceUnits,
			sportTypes: this.state.selectedSportTypeValues,
			services: this.state.selectedServiceValues,
			languages: this.state.selectedLanguageValues,
			abilityLevels: this.state.selectedAbilityLevelValues,
			genders: this.getValues(this.state.selectedGenderValues),
			trainingPeaksCertifications: this.getValues(this.state.selectedTrainingPeaksCertificationLevelValues),
		};
		this.props.onSearchSubmit(searchParams);
	},

	getValues: function (values) {
		return values.join(",");
	},

	handleKeywordsChange: function (e) {
		this.setState({
			keywords: e.target.value
		}, this.search);
	},

	handleLocationChange: function (e) {
		this.setState({
			location: e.target.value
		}, function () {
			this.toggleDistanceDisplay();
			this.search();
		});
	},

	handleSportTypeChange: function (values) {
		this.setState({
			selectedSportTypeValues: values
		}, this.search);
	},

	handleServicesChange: function (values) {
		this.setState({
			selectedServiceValues: values
		}, this.search);
	},

	handleLanguageChange: function (values) {
		this.setState({
			selectedLanguageValues: values
		}, this.search);
	},

	handleAbilityLevelChange: function (values) {
		this.setState({
			selectedAbilityLevelValues: values
		}, this.search);
	},

	handleGenderChange: function (value) {
		var genderValues = this.state.selectedGenderValues;

		if (genderValues.indexOf(value) > -1) {
			genderValues = genderValues.filter(i => i !== value);
		} else {
			genderValues = genderValues.concat(value);
		}

		this.setState({
			selectedGenderValues: genderValues
		}, this.search);
	},

	handleTrainingPeaksCertificationLevelChange: function (value) {
		var trainingPeaksCertificationLevels = this.state.selectedTrainingPeaksCertificationLevelValues;

		if (trainingPeaksCertificationLevels.indexOf(value) > -1) {
			trainingPeaksCertificationLevels = trainingPeaksCertificationLevels.filter(i => i !== value);
		} else {
			trainingPeaksCertificationLevels = trainingPeaksCertificationLevels.concat(value);
		}

		this.setState({
			selectedTrainingPeaksCertificationLevelValues: trainingPeaksCertificationLevels
		}, this.search);

	},

	handleRangeChange: function (value) {
		var newDistanceValue = parseInt(value) || initialDistance;
		this.setState({ distanceInput: newDistanceValue });

		if (this.state.distance !== newDistanceValue) {
			this.setState({ distance: newDistanceValue },
				this.search
			);
		}
	},

	handleRangeInputChange: function (value) {
		var newDistanceValue = parseInt(value) || "";
		this.setState({ distanceInput: newDistanceValue });
	},

	handleDistanceUnitsChange: function (value) {
		this.setState({
			selectedDistanceUnits: value
		}, this.search);
	},

	handleFormSubmit: function (event) {
		//prevent enter from submitting form causing post back to page
		event.preventDefault();
		event.stopPropagation();
		this.search();
	},

	toggleDistanceDisplay: function () {
		this.distance.style.display = (this.showDistanceAndUnits()) ? "block" : "none";
		this.selectedDistanceUnits.style.display = (this.showDistanceAndUnits()) ? "block" : "none";
	},

	resetForm: function () {
		this.setState({
			keywords: "",
			location: "",
			distance: initialDistance,
			distanceInput: initialDistance,
			selectedDistanceUnits: "mi",
			selectedSportTypeValues: "",
			selectedServiceValues: "",
			selectedLanguageValues: "",
			selectedAbilityLevelValues: "",
			selectedGenderValues: [],
			selectedTrainingPeaksCertificationLevelValues: []
		}, function () {
			var distanceSlider = "#" + distanceSliderId;
			new Foundation.Slider($(distanceSlider), { initialStart: initialDistance }); //moves the slider
			this.toggleDistanceDisplay();
		});
	},

	renderGenderOptions: function () {
		//case insensitive genders
		var selectedGenders = this.state.selectedGenderValues.map(function (element) { return element.toLowerCase(); });
		return this.props.genderOptions.map((item, index) => (
			<div className="columns medium-6" key={item.value + '-' + item.key}>
				<input type="checkbox" id={item.value + '-' + item.key} onChange={this.handleGenderChange.bind(this, item.key)} value={item.key} checked={selectedGenders.indexOf(item.key.toLowerCase()) > -1} /><label htmlFor={item.value + '-' + item.key}>{item.value}</label>
			</div>
		));
	},

	renderDistanceUnits: function () {
		return this.props.distanceUnitOptions.map((item, index) => (
			<span key={item.value + '-' + item.key}>
				<input type="radio" id={item.value + '-' + item.key} onChange={this.handleDistanceUnitsChange.bind(this, item.key)} name="distanceUnits" value={item.key} checked={this.state.selectedDistanceUnits.indexOf(item.key.toLowerCase()) > -1} /><label htmlFor={item.value + '-' + item.key}>{item.value}</label>
			</span>
		));
	},

	renderTrainingPeaksCertificationTooltip: function (certificationLevel) {
		var tooltip = trainingPeaksCertificationTooltips[certificationLevel];
		if (tooltip) {
			return (
				<span data-tooltip aria-haspopup="true" className="tooltipster-tooltip tooltip-help top" data-disable-hover="false"
					title={tooltip}>
					<i className="fi-info"></i>
				</span>
			);
		}

		return;
	},

	renderTrainingPeaksCertificationOptions: function () {
		return this.props.trainingPeaksCertificationOptions.map((item, index) => (
			<div className="columns medium-6" key={item.value + '-' + item.key}>
				<input type="checkbox" id={item.value + '-' + item.key} onChange={this.handleTrainingPeaksCertificationLevelChange.bind(this, item.key)} value={item.key} checked={this.state.selectedTrainingPeaksCertificationLevelValues.indexOf(item.key) > -1} />
				<label htmlFor={item.value + '-' + item.key}>{item.value} {this.renderTrainingPeaksCertificationTooltip(item.key)}</label>
			</div>
		));
	},

	render: function () {
		return (
			<div>
				<div className="coach-search-form-panel show-for-medium">
					<h3 className="u-text-3xl">Coach Search</h3>
					<form className="advancedSearchForm" onSubmit={this.handleFormSubmit}>
						<div className="row">
							<div className="columns medium-3">
								<label htmlFor="keywords">Keywords</label>
								<input type="text" id="keywords" placeholder="Ex: Trail Running" maxLength={100} onChange={this.handleKeywordsChange} value={this.state.keywords} />
							</div>
							<div className="columns medium-3">
								<label htmlFor="location">Location</label>
								<input type="text" id="location" placeholder="Ex: Boulder, Colorado" maxLength={100} onChange={this.handleLocationChange} value={this.state.location} />
							</div>
							<div className="columns medium-3" ref={(ref) => this.distance = ref}>
								<label htmlFor="keywords">Distance Range</label>
								<FoundationSlider maxValue={maxDistance} minValue={minDistance} value={this.state.distance} inputValue={this.state.distanceInput} onSliderChange={this.handleRangeChange} onSliderInputChange={this.handleRangeInputChange} step={distanceStep} id={distanceSliderId} />
							</div>
							<div className="columns medium-3" ref={(ref) => this.selectedDistanceUnits = ref}>
								<label className="margin-bottom-10">Distance Units</label>
								{this.renderDistanceUnits()}
							</div>
						</div>
						<div className="row">
							<div className="columns medium-3">
								<MultiSelect label="Sport Types" options={this.props.sportTypeOptions} labelKey={"value"} valueKey={"value"} onChange={this.handleSportTypeChange} value={this.state.selectedSportTypeValues} />
							</div>
							<div className="columns medium-3">
								<MultiSelect label="Services" options={this.props.serviceOptions} labelKey={"value"} valueKey={"value"} onChange={this.handleServicesChange} value={this.state.selectedServiceValues} />
							</div>
							<div className="columns medium-3">
								<MultiSelect label="Languages" options={this.props.languageOptions} labelKey={"value"} valueKey={"value"} onChange={this.handleLanguageChange} value={this.state.selectedLanguageValues} />
							</div>
							<div className="columns medium-3">
								<MultiSelect label="My Ability Level" options={this.props.abilityLevelOptions} labelKey={"value"} valueKey={"value"} onChange={this.handleAbilityLevelChange} value={this.state.selectedAbilityLevelValues} />
							</div>
						</div>
						<div className="row">
							<div className="columns medium-3">
								<label>Coach Gender</label>
								<div className="row">
									{this.renderGenderOptions()}
								</div>
							</div>
							<div className="columns medium-3">
								<label>TrainingPeaks Accreditation</label>
								<div className="row">
									{this.renderTrainingPeaksCertificationOptions()}
								</div>
							</div>
							<div className="columns medium-3 medium-offset-3">
								<a className="reset float-right" onClick={this.resetForm}>Clear All</a>
							</div>
						</div>
					</form>
				</div>
				<div className="coach-search-form-panel show-for-small-only">
					<h3 className="u-text-lg lg:u-text-3xl">Coach Search</h3>
					<form className="advancedSearchForm" onSubmit={this.handleFormSubmit}>
						<div className="row">
							<div className="columns small-12">
								<label htmlFor="keywords">Keywords</label>
								<input type="text" id="keywords" placeholder="Ex: Trail Running" onChange={this.handleKeywordsChange} value={this.state.keywords} />
							</div>
							<div className="columns small-12">
								<label htmlFor="location">Location</label>
								<input type="text" id="location" placeholder="Ex: Boulder, Colorado" maxLength={100} onChange={this.handleLocationChange} value={this.state.location} />
							</div>
						</div>
					</form>
				</div>
			</div>
		);
	}
});

module.exports = CoachSearchForm;
